import { Search01Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"

import { cn } from "@/lib/utils"

export function SearchForm({
  onOpen,
  className,
}: {
  onOpen: () => void
  className?: string
}) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className={cn(
        "flex h-9 min-w-0 max-w-full flex-1 items-center justify-start rounded-md border bg-background px-2.5 text-muted-foreground shadow-xs hover:bg-muted hover:text-foreground sm:max-w-[300px]",
        className,
      )}
    >
      <HugeiconsIcon icon={Search01Icon} strokeWidth={2} className="size-4 shrink-0" />
      <span className="ml-2 flex-1 truncate text-left text-sm">Поиск...</span>
      <kbd className="ml-2 hidden rounded border bg-muted px-1.5 py-0.5 text-[11px] text-muted-foreground sm:block">
        {navigator.platform.includes("Mac") ? "⌘K" : "Ctrl K"}
      </kbd>
    </button>
  )
}
